import React, { useState } from "react";
import ProductionDays from "../ProductionDays/ProductionDays";
import ProductionEmployees from "../ProductionEmployees/ProductionEmployees";
import Panel from "Components/Panel/Panel";
import "./OperationInformation.css";

const OperationInformation = (
    {
        onUpdateReloadProductionList,
        onUpdateProductionDaysIdSelecteds,
        onUpdateDecreaseProductionPanel,
        onUpdateDecreaseProductionPanelDay,
        productionIdSelecteds,
        productionDaysIdSelecteds,
        decreaseProductionPanel,
        decreaseProductionPanelDay,
        allowedAdvancedModule = { allowedAdvancedModule },
        onUpdateShowEmployesDayAllocatedPanel

    }) => {
    // Contador: cada chamada força o recarregamento, mesmo repetida
    const [reloadProductionDays, setReloadProductionDays] = useState(0)
    const [editingProductionDay, setEditingProductionDay] = useState(false)

    function reloadDays() {
        setReloadProductionDays(previous => previous + 1)
    }

    const handleClose = () => {
        onUpdateDecreaseProductionPanel(false)
        onUpdateReloadProductionList(true)
        onUpdateDecreaseProductionPanelDay(false)
        onUpdateProductionDaysIdSelecteds([])
    };

    function getLayoutModal() {
        if (!allowedAdvancedModule) {
            return 'main-modal not-visible'
        }

        if ((productionIdSelecteds && productionIdSelecteds.length === 1) &&
            (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) &&
            decreaseProductionPanelDay) {
            return 'main-modal not-visible'
        } else if (productionIdSelecteds && productionIdSelecteds.length === 1 &&
            decreaseProductionPanel) {
            return 'main-modal two right'
        } else {
            return 'main-modal'
        }
    }

    const mainOperationInformation = {
        displa: 'flex',
        flexDirection: 'column',
        transition: 'width 1.2s ease-in-out'
    };

    // Colaboradores ficam embaixo dos dias e mostram os do dia selecionado
    function getEmployeesSection() {
        if (editingProductionDay) {
            return null;
        }

        return (
            <div className='operation-information-section'>
                <ProductionEmployees
                    onUpdateReloadProductionList={onUpdateReloadProductionList}
                    productionIdSelecteds={productionIdSelecteds}
                    productionDaysIdSelecteds={productionDaysIdSelecteds}
                    onUpdateProductionDays={reloadDays}
                    reloadProductionDays={reloadProductionDays}
                    decreaseProductionPanelDay={decreaseProductionPanelDay}
                />
            </div>
        )
    }

    if (productionIdSelecteds && productionIdSelecteds.length === 1 && decreaseProductionPanel) {
        return (
            <Panel style={mainOperationInformation} className={getLayoutModal()}>
                <div className='operation-information-body'>
                    <div className='operation-information-section'>
                        <ProductionDays
                            onUpdateReloadProductionList={onUpdateReloadProductionList}
                            onUpdateProductionDaysIdSelecteds={onUpdateProductionDaysIdSelecteds}
                            onUpdateDecreaseProductionPanelDay={onUpdateDecreaseProductionPanelDay}
                            productionIdSelecteds={productionIdSelecteds}
                            productionDaysIdSelecteds={productionDaysIdSelecteds}
                            onUpdateProductionDays={reloadDays}
                            reloadProductionDays={reloadProductionDays}
                            decreaseProductionPanelDay={decreaseProductionPanelDay}
                            handleClose={handleClose}
                            onUpdateShowEmployesDayAllocatedPanel={onUpdateShowEmployesDayAllocatedPanel}
                            onUpdateEditing={setEditingProductionDay}
                        />
                    </div>
                    {getEmployeesSection()}
                </div>
            </Panel >

        )
    } else {
        return null
    }
}
export default OperationInformation;
